/*
 * Utils
 *
 * Display, update information of SubAccount
 **/

import { XLOLOI_COLLAB } from '../common/constant';

// Private Functions
let USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  trailingZeroDisplay: 'stripIfInteger',
});
export const formatCurrency = (money = '') => {
  return USDollar.format(money);
};

/**
 * submissionSuccessHandler
 * Create subaccount customers in MU app API
 *
 * @param {object} $form - jQuery object of the form wrapper
 * @param {string} message - success message
 */
export const submissionSuccessHandler = ($formWrapper = null, message = '') => {
  const responseContainerClass = 'js-form-submit-response';
  const $message = $formWrapper.find(`.${responseContainerClass}`);

  $formWrapper.find('.js-accordion-trigger').trigger('click');
  $message.removeClass('hidden').html(message);
  setTimeout(() => {
    $message.addClass('hidden');
  }, 5000);
};

/**
 * permissionErrorHandler
 * Displat error massage saying "Access Denied".
 *
 * @param {object} targetClass - target DOM to insert this message
 * @param {string} additionalClass - any addtional class to the error message
 */
export const permissionErrorHandler = (
  targetClass = '',
  additionalClass = '',
) => {
  $(`.${targetClass}`).html(`
    <p class='type-utility-small-regular text-red ${additionalClass}'>
      Error: Access denied due to no permission.
    </p>`);
};

/**
 * Updated Value Helper
 * @param {object} form - Target Form
 * @param {string} selector - element selector to get NEW target value
 * @param {object} original - ORIGINAL value
 */
export const getUpdatedValueHelper = (form, selector, original) => {
  return $(form).find(selector).val() ? $(form).find(selector).val() : original;
};

export const updateValueHelper = (target = {}, dataName = null) => {
  $.each(target, (index, item) => {
    if ($(item).is('select') && dataName) {
      // Value Update
      $(item)
        .val(custom.utils.titleCase(dataName))
        .data('default', custom.utils.titleCase(dataName));

      // Exception Handler for Country, Province Selector
      if ($(item).hasClass('js-address-province-option')) {
        window.pubsub.trigger('updatedProvinceValue', {
          className: 'js-address-province-option',
          value: custom.utils.titleCase(dataName),
        });
      }
      if ($(item).hasClass('js-address-country-option')) {
        window.pubsub.trigger('updatedCountryValue', {
          className: 'js-address-country-option',
          value: custom.utils.titleCase(dataName),
        });
      }
    } else {
      $(item).is('input') ? $(item).val(dataName) : $(item).html(dataName);
    }
  });
};

/**
 * Get Url Query Object
 * @function
 *
 * return an object contains key and value in url
 */
export const getUrlQueryObject = () => {
  const queryArr = window.location.search.substring(1).split('&');
  let queryObj = {};

  queryArr.forEach((str) => {
    const key = str.substring(0, str.indexOf('='));
    const newObj = {};
    newObj[key] = str.substring(str.indexOf('=') + 1);
    queryObj = Object.assign({}, queryObj, newObj);
  });

  return queryObj;
};

/**
 * getTemplateName
 * @function
 *
 * return view attribute in URL query string
 * ex) /account?view=order-history returns 'order-history'
 */
export const getTemplateName = (query = null) => {
  query = !query ? getUrlQueryObject() : query;
  return query.view;
};

/**
 * getOrderId
 * @function
 *
 * return SPARS(Shopify) order ID
 * if url query string has 'order-history' view attribute & id
 */
export const getOrderId = (query = null) => {
  query = !query ? getUrlQueryObject() : query;
  return (query.view == 'order-history' || 'return') && query.orderId
    ? query.orderId
    : null;
};

/**
 * displayOrderId
 * @function
 *
 * @param {string} id - SPARS(Shopify) order ID
 * @param {string} class - target DOM selector
 *
 * Injects SPARS order ID in DOM
 */
export function displayOrderId(id = null, className = '') {
  $(`.${className}`).text(id);
}

export const orderObjectReducer = (order = {}) => {
  const itemsToShow = { desktop: 3, mobile: 2, homepage: 1 };
  const date = new Date(order.Header.OrderDate);
  order.Header.OrderDate = date.toDateString();
  // let orderItemSummary = ""; // for Product Title Search

  if (order.Detail) {
    order.Detail = order.Detail.filter((detail) => {
      return detail.ShopifyID !== '';
    });
    order.Detail.forEach((detail) => {
      detail.formattedUnitPrice = formatCurrency(detail.UnitPrice);
      // orderItemSummary += detail.ShopifyItem.title;
    });
  }
  if (
    order.Header &&
    (!order.Header.OrderStatus || !order.Header.OrderStatus.length)
  ) {
    if (order.Header.Status) {
      order.Header.OrderStatus =
        order.Header.Status.charAt(0).toUpperCase() +
        order.Header.Status.slice(1).toLowerCase();
    } else {
      order.Header.OrderStatus = 'Open';
    }
  } else {
    // Because carriers cannot all provide delivered status, just show delivered status as "Shipped"
    if (
      order.Header.OrderStatus &&
      (order.Header.OrderStatus === 'Delivered' ||
        order.Header.OrderStatus === 'delivered')
    ) {
      order.Header.OrderStatus = 'Shipped';
    }
  }

  //extract querystring var for Invoice URL
  order.Header.InvoiceID = order.Header.InvoiceUrl
    ? order.Header.InvoiceUrl.split('?p_Order=')[1]
    : '';

  // Handling tracking URL CTAs for different scenarios
  let viewToTrack = false;
  let localDelivery = false;
  let customerPickUp = false;
  if (
    (order.Header.OrderStatus == 'Shipped' ||
      order.Header.OrderStatus == 'Partially Shipped' ||
      order.Header.OrderStatus == 'FULFILLED') &&
    order.Header.TrackingURL == ''
  ) {
    viewToTrack = true;
  }
  if (order.Header.ShipViaCode == 'CSPU') {
    customerPickUp = true;
    localDelivery = false;
    viewToTrack = false;
  }
  if (order.Header.ShipViaCode == 'DELI') {
    customerPickUp = false;
    localDelivery = true;
    viewToTrack = false;
  }

  order = {
    ...{
      Info: {
        items: order.Detail.length,
        formattedTotal: formatCurrency(order.Header.TotalAmount),
        formattedSubTotal: formatCurrency(order.Header.SubTotal),
        formattedOrderDate: `${
          date.getMonth() + 1
        }/${date.getDate()}/${date.getFullYear()}`,
        viewToTrack: viewToTrack,
        localDelivery: localDelivery,
        customerPickUp: customerPickUp,
        // itemsSummary: orderItemSummary,
        itemsRemainingDesktop:
          order.Header.ProductCount - itemsToShow.desktop > 0
            ? order.Header.ProductCount - itemsToShow.desktop
            : false,
        itemsRemainingMobile:
          order.Header.ProductCount - itemsToShow.mobile > 0
            ? order.Header.ProductCount - itemsToShow.mobile
            : false,
        itemsRemainingHomepage:
          order.Header.ProductCount - itemsToShow.homepage > 0
            ? order.Header.ProductCount - itemsToShow.homepage
            : false,
        hasImages: order.Detail.some(
          (detail) => detail.ShopifyItem && detail.ShopifyItem.image,
        ),
      },
    },
    ...order,
  };

  return order;
};

export const orderDetailObjectReducer = (order = {}) => {
  const date = new Date(order.Header.OrderDate);
  order.Header.OrderDate = date.toDateString();
  let totalQty = 0;
  let returns = [];

  //add Terms to payment
  if (order.Header.PaymentTerm.toUpperCase() != 'PREPAID') {
    order.Header.PaymentTerm =
      'Terms: ' + custom.utils.titleCase(order.Header.PaymentTerm);
  }

  //extract querystring var for Invoice URL
  order.Header.InvoiceID = order.Header.InvoiceUrl
    ? order.Header.InvoiceUrl.split('?p_Order=')[1]
    : '';

  function applyProductDetailInfo(detailArray) {
    //Filter out items with no Shopify ID
    const filteredDetails = detailArray.filter((detail) => {
      return detail.ShopifyID !== '';
    });
    filteredDetails.forEach((detail, index, object) => {
      const tagArr = detail.ShopifyItem.tags.split(', ');

      // Collection Name
      detail.collection = tagArr.filter((tag) => !tag.indexOf('Collection:'))[0]
        ? custom.utils.titleCase(
            tagArr
              .filter((tag) => !tag.indexOf('Collection:'))[0]
              .replace('Collection:', ''),
          )
        : null;

      // Collaboration Name
      const collaborationName = tagArr.filter(
        (tag) => !tag.indexOf('Collaboration:'),
      )[0]
        ? tagArr
            .filter((tag) => !tag.indexOf('Collaboration:'))[0]
            .replace('Collaboration:', '')
        : null;
      const excludedCollaborations = ['Loloi'];

      detail.collaboration = excludedCollaborations.includes(collaborationName)
        ? null
        : collaborationName; // Move this out to a custom util function?
      detail.x_loloi =
        XLOLOI_COLLAB.indexOf(collaborationName) >= 0 ? true : false;
      // Not Found Handler
      // The case there's no corresponsing product anymore on Shopify
      if (detail.ShopifyID == '') {
        detail.ShopifyItem.title = detail.ItemID;
        if (detail.ShopifyItem.variant && detail.ShopifyItem.variant.title)
          detail.ShopifyItem.variant.title = '';
      }
      if (!detail.ShopifyItem.image) {
        detail.ShopifyItem.image = orderNoImgSrc;
        detail.imageless = true;
      } else {
        detail.imageless = false;
      }
      //Add Returns to their own list, and subtract returned quantity from total.
      if (detail.ReturnQty > 0) {
        let clone = Object.assign({}, detail);
        clone.Qty = detail.ReturnQty;
        returns.push(clone);
        if (detail.ReturnQty >= detail.Qty) {
          object.splice(index, 1);
        } else {
          detail.Qty = detail.Qty - detail.ReturnQty;
        }
      }
      detail.formattedUnitPrice = formatCurrency(detail.UnitPrice);
      totalQty += detail.Qty;
    });
    return filteredDetails;
  }

  if (order.Shipments.length > 0)
    order.Shipments.forEach((shipment, index, object) => {
      shipment.DeliveryNo = index + 1;
      shipment.Detail = applyProductDetailInfo(shipment.Detail);
      if (shipment.Detail.length <= 0) object.splice(index, 1);
    });

  if (order.PreparingToShip.length > 0) {
    order.PreparingToShip = applyProductDetailInfo(order.PreparingToShip);
  }

  if (order.Pendings.length > 0) {
    order.Pendings = applyProductDetailInfo(order.Pendings);
  }

  if (order.Cancel.length > 0) {
    order.Cancel = applyProductDetailInfo(order.Cancel);
  }

  order = {
    ...{
      Returns: returns,
      TotalItems: totalQty,
      isPendings:
        order.Pendings.length > 0 && order.Header.OrderStatus === 'Pending'
          ? true
          : false,
      isPreparingToShip: order.PreparingToShip.length > 0 ? true : false,
      isShipments:
        (order.Shipments.length > 0 &&
          order.Header.OrderStatus === 'Shipped') ||
        order.Header.OrderStatus === 'Delivered' ||
        order.Header.OrderStatus === 'delivered'
          ? true
          : false,
      isPreparingOrPending:
        order.PreparingToShip.length > 0 || order.Pendings.length > 0
          ? true
          : false,
      isCancels: order.Cancel.length > 0 ? true : false,
      Info: {
        formattedTotal: formatCurrency(order.Header.TotalAmount),
        formattedSubTotal: formatCurrency(order.Header.SubTotal),
      },
    },
    ...order,
  };

  return order;
};



// WEBPACK FOOTER //
// ./src/scripts/src/account/utils.js